<template>
    <div class="content">
        <div class="actorDetail">
            <div class="actorDetail__container">
                <div class="actorDetail__wrapper">
                    <div class="actorDetail__img">
                        <img
                            :src="noImageAvailable"
                            :alt="getActorDetail?.name"
                            v-if="getActorDetail"
                        />
                        <div
                            v-else
                            class="actorDetail__loader actorDetail__loader--img"
                        ></div>
                    </div>
                    <div class="actorDetail__info">
                        <h1 class="actorDetail__name" v-if="getActorDetail">
                            {{ getActorDetail?.name }}
                        </h1>
                        <div
                            class="actorDetail__loader actorDetail__loader--name"
                            v-else
                        ></div>
                        <p
                            class="actorDetail__profession big"
                            v-if="getActorDetail"
                        >
                            {{ getActorDetail?.profession }}
                        </p>
                        <div
                            class="actorDetail__loader actorDetail__loader--profession"
                            v-else
                        ></div>
                        <p
                            class="actorDetail__profession"
                            v-if="getActorDetail?.country"
                        >
                            <b>Страна:</b> {{ getActorDetail?.country }}
                        </p>
                        <p
                            class="actorDetail__profession"
                            v-if="getActorDetail?.birthdate"
                        >
                            <b>Год рождения:</b> {{ getActorDetail?.birthdate }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div id="oid">
            <div class="main_second_wrapper">
                <h2 class="title">Фильмография:</h2>

                <div
                    class="movie_list_wrap"
                    v-if="movies.length"
                    :key="$route.href"
                >
                    <movie-list :movie-items="movies" />
                </div>
                <div
                    class="movie_list_wrap"
                    :key="cardCount"
                    ref="lasteElemRef"
                    v-if="isLoadingincCurrent"
                >
                    <movie-list :isLoading="true" :cardCount="cardCount * 2" />
                </div>
                <div
                    v-if="!movies.length && !isLoadingincCurrent"
                    class="filter_not_found"
                >
                    <img src="../../../assets/assets/notFind.png" alt="Tvcom" />
                    <div class="filter_not_found_descr">
                        {{ $t("message.filter.notFound") }}
                    </div>
                </div>
            </div>
        </div>

        <div ref="listItemRef"></div>

        <div v-if="isLoading" class="loader">
            <semipolar-spinner
                :animation-duration="2000"
                :size="100"
                color="#ff1d5e"
            />
        </div>
    </div>
</template>
<script>
import { SemipolarSpinner } from "epic-spinners";
import { getMovies } from "../../Api";
import { mapGetters } from "vuex";
import MovieCard from "../../components/MovieCard.vue";
import MovieList from "../../components/MovieList.vue";
import noImageAvailable from "../../../assets/assets/noImageAvailable.webp";

export default {
    components: {
        SemipolarSpinner,
        MovieCard,
        MovieList,
    },

    props: ["parent"],

    data() {
        return {
            isLoading: true,
            isLoggedIn: false,
            isLastPage: false,
            // movies: [],
            page: 1,
            abortController: null,
            activeCinema: null,
            changingRoute: false,
            showFilter: true,
            pageTitle: "",
            noImageAvailable: noImageAvailable,
            windowInnerWidth: window.innerWidth,
            cardCount: 0,
        };
    },

    mounted() {
        this.verifyAccess();
        this.scroll();
        this.changingRoute = true;
        window.addEventListener("resize", this.windowResize());
        this.canShowFilter();
    },

    beforeUnmount() {
        window.removeEventListener("resize", this.windowResize());
        window.removeEventListener("scroll", this.loadMore);
    },

    watch: {
        $route: {
            handler(to, from) {
                if (
                    !to.name.match(/(movies|serials|kids|uzb|personFilms)/)?.[0]
                )
                    return;
                if (to.name === "movie" && from.name === "movies") return;
                if (to.name === "movie" && from.name === "serials") return;
                if (to.name === "movie" && from.name === "kids") return;
                if (to.name === "movie" && from.name === "uzb") return;
                if (to.name === "movie" && from.name === "personFilms") return;
                if (to.name === "movie" && from.name === "search") return;
                if (to.name === "search") return;
                this.canShowFilter();
                this.chekPage();
                this.verifyAccess();
                this.updateStore(true, to.href);
                this.changingRoute = true;
                this.isLastPage = false;
                window.scrollTo(0, 0);
            },
            immediate: true,
        },
        getActorDetail(value) {
            if (value?.photo) {
                this.noImageAvailable = value.photo;
            }
            document.title = this.appendActorTitle(value);
            document.description = this.appendActorDesc(value);
        },
    },

    computed: {
        ...mapGetters([
            "getMovieList",
            "getWorld",
            "getUzbState",
            "getPagesCount",
            "getActorDetail",
            "getActorDetailLoading",
        ]),
        movies() {
            return this.getMovieList[this.$route.href]?.list || [];
        },
        isLoadingincCurrent() {
            return this.getMovieList[this.$route.href]?.isLoading;
        },
        lang() {
            return this.$i18n.locale;
        },
    },
    created() {
        this.findPageTitle();
        this.$store.dispatch("fetchActorDetail", this.$route.params.provider);
        this.cardsCountInRow();
    },
    methods: {
        windowResize() {
            this.windowInnerWidth = window.innerWidth;
        },
        cardsCountInRow() {
            const rowsCount = 3;
            const columns = {
                1920: 9,
                1440: 6,
                1024: 5,
                992: 4,
                576: 3,
                320: 2,
            };

            let cardCount = 0;

            // Find the largest width that is smaller than or equal to windowInnerWidth
            for (let width of Object.keys(columns).reverse()) {
                if (this.windowInnerWidth > width) {
                    cardCount = columns[width];
                    break;
                }
            }
            this.cardCount = cardCount;
            return cardCount * rowsCount;
        },
        canShowFilter() {
            const routeName = this.$route.name;

            if (routeName === "uzb" || routeName === "personFilms")
                this.showFilter = false;

            if (
                routeName === "movies" ||
                routeName === "serials" ||
                routeName === "kids"
            ) {
                this.showFilter = true;
            }
        },
        appendActorTitle(actor) {
            return `${actor.name} | ${actor.country} | ${actor.profession} | Биография, Фильмография и Новости`;
        },

        appendActorDesc(actor) {
            return `${actor.name} | ${actor.country} | ${
                actor.profession
            } | Узнайте больше о ${actor.name} ${
                actor.type ? "актёре" : "режиссере"
            } — , который прославился благодаря своим выдающимся ролям/фильмам. Биография, фильмография. Все о творческом пути.`;
        },

        verifyAccess() {
            if (
                localStorage.getItem("access") === "true" &&
                localStorage.getItem("token")
            ) {
                this.isLoggedIn = true;
            } else {
                this.isLoggedIn = false;
                localStorage.setItem("access", false);
            }
        },

        setActiveCinema(item, updateRoute) {
            this.activeCinema = item;

            if (updateRoute) return;

            if (!item) {
                this.$router.push({
                    path: this.parent,
                });

                return;
            }

            if (item.genre === "uzb") {
                this.$router.push({
                    query: { genre_any: item.id },
                });

                return;
            }

            this.$router.push({
                path: `${this.parent || this.$route.path}/${item.provider_id}`,
            });
        },
        chekPage() {
            const routerHref = this.$route.href;
            const list = this.getMovieList;
            if (list[routerHref]) {
                this.$store.commit("countPages", list[routerHref].page);
            } else {
                this.$store.commit("resetPages");
            }
        },
        async getVideoContent(loadMore, r_key) {
            const route = this.$route;
            const query = route.query;

            this.isLoading = true;

            const provider_id =
                route.params?.provider === "undefined"
                    ? undefined
                    : route.params?.provider;
            const routePath = route.path.split("/")?.[1];

            const routeParams = {
                movies: {
                    cgid: provider_id
                        ? null
                        : this.$route.query.cgid
                        ? this.$route.query.cgid
                        : 260,
                    season: "0",
                    year_from: 2019,
                    year_to: 2024,
                    order: "-created_at",
                    video_provider_id: provider_id,
                },
                serials: {
                    cgid: provider_id
                        ? null
                        : this.$route.query.cgid
                        ? this.$route.query.cgid
                        : 260,
                    season: "1",
                    order: "-created_at",
                    video_provider_id: provider_id,
                },
                kids: {
                    cgid: provider_id
                        ? null
                        : this.$route.query.cgid
                        ? this.$route.query.cgid
                        : 260,
                    genre_any: "209,161,104,249,241",
                    year_from: 2009,
                    year_to: 2024,
                    order: "-created_at",
                    video_provider_id: provider_id,
                },
                uzb: {
                    genre_any: provider_id,
                },
                personFilms: {
                    aid: provider_id,
                    clear: true,
                },
                "movies-filter": {
                    season: 0,
                },
                "serials-filter": {
                    season: 1,
                },
            };

            const routeQuery = {
                movies: {
                    season: "0",
                    genre_any: query.genre_any,
                    extra_genre: query.extra_genre,
                    video_provider_id: query.video_provider_id,
                    country: query.country,
                    year: query.year,
                    order: query.order,
                    cgid: query.cgid,
                },
                serials: {
                    season: "1",
                    genre_any: query.genre_any,
                    video_provider_id: query.video_provider_id,
                    country: query.country,
                    year: query.year,
                    order: query.order,
                    cgid: query.cgid,
                },
                kids: {
                    genre_any: "209,161,104,249,241",
                    extra_genre: query.extra_genre,
                    video_provider_id: query.video_provider_id,
                    country: query.country,
                    year: query.year,
                    order: query.order,
                    cgid: query.cgid,
                },
                uzb: {
                    genre_any: query.genre_any,
                },
            };
            const hasFilter =
                query.country ||
                query.year ||
                query.genre_any ||
                query.extra_genre ||
                query.video_provider_id ||
                query.order
                    ? true
                    : false;
            const params = hasFilter
                ? routeQuery[route.name]
                : routeParams[routePath];

            const reqParams = [
                this.isLoggedIn,
                {
                    page: this.getPagesCount,
                    limit: this.cardsCountInRow(),
                    lang: this.$i18n.locale == "uz" ? "fr" : "ru",
                    ...params,
                },
            ];
            this.$store.commit("updateMovieList", {
                key: r_key,
                page: this.getPagesCount,
                isLoading: true,
            });
            const list = await getMovies(...reqParams);

            let movies = [];
            if (loadMore && !list?.length) {
                this.isLastPage = true;
            }
            if (this.getMovieList[r_key]?.list) {
                movies = [
                    ...this.getMovieList[r_key].list,
                    ...this.filterMovies(list),
                ];
            } else {
                movies = this.filterMovies(list);
            }

            this.$store.commit("updateMovieList", {
                key: r_key,
                page: this.getPagesCount,
                list: movies,
                isLoading: false,
            });
            this.isLoading = false;
        },
        findPageTitle() {
            const provider = this.$route.params?.provider;
            if (provider) {
                const item = this.getUzbState.find((item) => {
                    return item.id == provider;
                });
                this.pageTitle = item?.pageTitlte;
            }
        },
        filterMovies(movies) {
            let filtered = movies;

            filtered = this.getWorld
                ? filtered?.filter(
                      (i) =>
                          i.video_provider_id != 3 &&
                          i.video_provider_id != "None" &&
                          i.video_provider_id != null
                  )
                : filtered;

            filtered = filtered?.filter((i) => !Array.isArray(i));

            return filtered;
        },

        updateStore(toggle, r_key) {
            if (this.getMovieList[r_key]?.list.length) {
                this.isLoading = false;
            } else {
                this.getVideoContent(false, r_key);
            }
        },

        scroll() {
            // window.scrollTo({
            //     top: 0,
            //     behavior: "auto",
            // });
            if (!this.movies.length && !this.isLoading) return;
            addEventListener("scroll", this.loadMore);
        },

        loadMore() {
            const scrollBottom =
                window.innerHeight + window.scrollY >=
                document.body.offsetHeight - 400;

            if (scrollBottom && !this.isLoading && !this.isLastPage) {
                this.$store.commit("countPages");
                this.getVideoContent(true, this.$route.href);
            }
        },

        closeFilter() {
            this.$store.commit("setOpenFilter", false);
        },
    },
};
</script>
<style lang="scss" scoped>
.actorDetail {
    margin: 0 0 30px;
    &__container {
        width: 90%;
        margin: 0 auto;
    }
    &__wrapper {
        display: flex;
        align-items: center;
        gap: 30px;
    }
    &__img {
        height: 280px;
        width: 200px;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    &__name {
        font-size: 2.5rem;
        font-weight: 500;
        margin-bottom: 15px;
    }
    &__profession {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 10px;
        &.big {
            font-size: 24px;
            margin-bottom: 15px;
        }
    }
    &__loader {
        background: linear-gradient(
            100deg,
            #3f3f3f 30%,
            #e41a4b 50%,
            #3f3f3f 70%
        );
        background-size: 500%;
        animation: loading 1s ease-in-out infinite;
        &--img {
            height: 280px;
            width: 200px;
        }
        &--name {
            height: 40px;
            width: 180px;
            margin-bottom: 15px;
        }
        &--profession {
            height: 30px;
            width: 170px;
            margin-bottom: 10px;
        }
    }
}
@keyframes loading {
    0% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0 50%;
    }
}
@media (max-width: 575.98px) {
    .actorDetail {
        &__wrapper {
            flex-direction: column;
        }
        &__img {
            height: 150px;
            width: 120px;
        }
        &__name {
            font-size: 2rem;
            text-align: center;
        }
        &__info {
            width: 100%;
        }
        &__profession {
            text-align: center;
        }
        &__loader {
            &--img {
                height: 150px;
                width: 120px;
            }
        }
    }
}
</style>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.filter_not_found {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin-top: 9rem;
    height: 55vh;
}

.filter_not_found > img {
    width: 250px;
}

.filter_not_found_descr {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    font-size: 1.2rem;
    color: #767676;
    font-weight: 500;
    text-align: center;
    max-width: 25rem;
}

.content {
    padding-top: 15px;
}

.movie_list_wrap {
    margin-top: 20px;
    width: 90%;
}
.full_height {
    height: calc(100vh - 120px);
}
.activeFilter {
    border: 2px solid #e41a4b;
}
.serialCart {
    max-width: 50px;
    max-height: 50px;
    position: absolute;
    right: 0;
    top: 0;
}
.filterBlock {
    width: 100%;
    padding: 20px 0;
    display: flex;
    margin-top: 0px;
    margin-bottom: 0px;
    justify-content: space-between;
}
.searchIcon {
    width: 23px;
}
.filterBtn {
    display: flex;
    background-color: #313131;
    gap: 10px;
    padding: 10px;
    border-radius: 10px;
    margin-right: 5px;
    background-color: #1c1c1c;
    cursor: pointer;
}
.filterBtn p {
    margin: 0;
}
.start {
    max-width: 86px !important;
}
.moreTv {
    max-width: 86px !important;
    left: 0 !important;
}
.moreTv img {
    max-width: 80px !important;
}
.main_wrapeer {
    display: flex;
    flex-direction: column;
}
.main_category_name_text_wr {
    width: 90%;
    margin: 0 auto 20px;
}

.title {
    max-width: 90%;
    width: 100%;
    text-align: left;
    font-size: 30px;
}

.main_second_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    flex-direction: column;
    gap: 10px;
}
.main_category_name_text {
    font-family: "Suisse Intl";
    font-weight: 400;
    font-size: 24px;
    color: #fff;
    margin: 20px 0;
}
.items_wrapper {
    padding: 1rem;
    gap: 0.8rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(12rem, 14rem), 1fr));
    width: 90%;
}

.wraperCard:hover {
    border-radius: 7px;
    box-shadow: 1px 1px 10px 10px #e41a4b;
}
.items_wrapper_item_name {
    font-family: "Suisse Intl";
    font-weight: 400;
    font-size: 12px;
    height: 40px;
    color: #fff;
    text-align: center;
    margin: 0;
}
.items_wrapper_item_img {
    width: 100%;
    position: absolute;
    height: 210px;
    border-radius: 7px;
    top: 0;
    left: 0;
    right: 0;
}
button {
    color: #e41a4b;
    background-color: #fff;
    padding: 5px 10px 5px 10px;
}
.title_name {
    display: flex;
    justify-content: center;
}
.loader {
    width: 100%;
    position: relative !important;
    justify-content: center;
    display: flex;
    align-items: center;
    padding: 50px 0;
}

.pageLoader {
    width: 100%;
    position: relative !important;
    justify-content: center;
    display: flex;
    align-items: center;
    height: calc(100vh - 80px);
}

.filter_select {
    padding: 5px 25px;
    background-color: #e41a4b;
    color: #fff;
    border: none;
    outline: none;
}
.janrItem {
    cursor: pointer;
    width: 180px;
    height: 220px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.janrcard {
    display: flex;
    border-radius: 7px;
    background-color: #1c1c1c;
    width: 180px;
    height: 190px;
}
.textJanr {
    cursor: pointer;
    padding: 10px 0;
    border-radius: 7px;
    background-color: #1c1c1c;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
}
.textJanr h3 {
    font-size: 14px;
    margin-left: 0;
    margin-top: 0;
    margin-bottom: 0;
    font-family: "Suisse Intl";
}
.refreshWrapper {
    width: 90vw;
    margin: 0 auto 20px;
}
.refresh {
    width: 300px;
    background-color: #e41a4b;
    height: 40px;
    margin-left: 20px;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 0 auto;
}
.arrowBottom {
    width: 20px;
    height: 20px;
    background-size: contain;
    background-image: url("../../../assets/icons/arrow.svg");
    background-repeat: no-repeat;
    margin-top: 10px;
    margin-left: 7px;
    transform: rotate(90deg);
}
.name {
    display: none;
}
@media screen and (max-width: 800px) {
    .main_second_wrapper {
        gap: 0;
    }
    .title {
        max-width: 95%;
    }
    .movie_list_wrap {
        width: 95%;
    }

    .name {
        display: block;
        font-family: "Suisse Intl";
        width: 90%;
        font-size: 20px;
        margin: 10px auto 20px;
    }

    .items_wrapper {
        padding: 0.5rem;
        gap: 0.7rem;
        grid-template-columns: repeat(auto-fill, minmax(min(8rem, 100%), 1fr));
    }
}
@media screen and (max-width: 420px) {
    .movie_list_wrap {
        width: 95%;
    }

    .janrItem {
        width: 180px;
        height: 210px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .wraperCard {
        width: 133px;
    }
    .items_wrapper_item_img {
        height: 190px;
    }

    .janrcard {
        border-radius: 7px;
        background-color: #1c1c1c;
        width: 150px;
        height: 180px;
    }
}
</style>
